module.exports = __webpack_public_path__ + "static/media/robots.9152d7f1.txt";